import { resources } from 'redux-and-the-rest';

import { GameScoreModel } from '../../models/gameScoreModel';
import Env from '../../utils/env';
import { userActions } from './userReducer';

const {
  reducers: leaderboardGameScoresReducer,
  getOrFetchList: getOrFetchLeaderboardGameScores,
} = resources<GameScoreModel>(
  {
    name: 'leaderboardGameScore',
    url: `${Env.API_URL}/current_user/leaderboard/game_scores`,
    clearOn: [
      userActions.clearItem as string,
    ],
  },
  {
    fetchList: true,
  },
);

export {
  leaderboardGameScoresReducer,
  getOrFetchLeaderboardGameScores,
};
